
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GroupsForMaintenance from "./GroupForMaintenance.vue";

@Component({
  components: {
    GroupsForMaintenance
  },
})
export default class GroupModal extends Vue {

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
